import React from "react";
import AboutComponent from "../components/AboutSection";

export const About = () =>  <AboutComponent/>;